import { Typography } from "@fullscreendigital/carrefour-dex-fe";
import { URLS } from '../../../../constants'
import { generatePath, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { TitleHeader } from '../../../../Common/TitleHeader'
import { makeCoreGetRequest } from "../../../../../../../utils/api"
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import { useNotification } from '../../../../../../../hooks'
import { useQuery } from 'react-query'
import { CircularProgress, Container, InputAdornment, Paper, TextField } from "@mui/material"
import { Grid } from '@mui/material'
import React, { useCallback, useMemo } from "react"
import SearchIcon from '@mui/icons-material/Search'

const OrderList = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { showNotification } = useNotification()
  const [sp, setSp] = useSearchParams()
  const rayonCode = sp.get('rayonCode')
  const q = sp.get('q') || ''

  const { data: orderList, isLoading } = useQuery(
    ['orderList', id, rayonCode],
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/ds-order/list/${id}/${rayonCode}`, null)
    },
    {
      enabled: Boolean(id && rayonCode),
      onError: error => {
        showNotification({
          message: `Error while fetching orders. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const onSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    const nextParams = new URLSearchParams(sp)
    if (next) nextParams.set('q', next)
    else nextParams.delete('q')
    setSp(nextParams, { replace: true })
  }, [sp, setSp])

  const filteredOrders = useMemo(() => {
    const list = orderList ?? []
    const term = q.trim().toLowerCase()
    if (!term) return list
    return list.filter((o: any) => String(o?.orderNumber ?? '').toLowerCase().includes(term))
  }, [orderList, q])

  if (!rayonCode) {
    return <Typography variant="medium" style={{ margin: '100px' }}>Lipsește rayonul selectat.</Typography>
  }

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="Selecteazǎ Comanda" />
        </Grid>

        <Grid item xs={12}>
          <TextField
            value={q}
            onChange={onSearchChange}
            placeholder="Caută după număr comandă"
            fullWidth
            size="small"
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              )
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Container maxWidth="xs">
            <Grid container spacing={1}>
              {filteredOrders.length === 0 && (
                <Grid item xs={12}>
                  <Typography variant="medium" component="p" style={{ margin: '10px' }}>
                    Nicio comandă{q ? ` pentru căutarea “${q}”` : ''}.
                  </Typography>
                </Grid>
              )}

              {filteredOrders?.map((order: any) => (
                <Grid item xs={12} key={order.id}>
                  <Paper
                    elevation={3}
                    style={{ margin: '10px', padding: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      navigate(generatePath(URLS.AUTH_SUPPLIERS_ORDER_DETAILS, { id: order.id }) + `?supplierCode=${id}`)
                    }}
                  >
                    <Typography variant="medium" component="h5">
                      Număr comandă: {order.orderNumber}
                    </Typography>
                    <Typography variant="medium" component="h5">
                      {order.shopCode}
                    </Typography>
                    <Typography variant="medium" component="p">
                      {order.rayonName}
                    </Typography>
                    {order.dsDeliveryStatusValue !== undefined && order.dsDeliveryStatusValue !== null && (
                      <Typography variant="medium" component="p">
                        {order.dsDeliveryStatusValue}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  )
}

export default OrderList
